import { Button } from '../ui/button';
import { cn } from '@/client/utils';
import { useTranslation } from 'react-i18next';

type TreadSwitchProps = {
  type: 'buy' | 'sell';
  setType: (type: 'buy' | 'sell') => void;
};
export const TreadSwitch = ({ type, setType }: TreadSwitchProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center rounded-t-3.5 border-b border-foreground/4">
      <Button
        variant="ghost"
        onClick={() => setType('buy')}
        className={cn(
          'shadow-none rounded-b-none px-2 hover:bg-transparent border-b-2 border-transparent',
          type === 'buy' ? 'border-foreground' : 'text-foreground/70'
        )}
      >
        {t('buy')}
      </Button>
      <Button
        variant="ghost"
        onClick={() => setType('sell')}
        className={cn(
          'shadow-none rounded-b-none px-2 hover:bg-transparent border-b-2 border-transparent',
          type === 'sell' ? 'border-foreground' : 'text-foreground/70'
        )}
      >
        {t('sell')}
      </Button>
    </div>
  );
};
